import { useQuery } from '@tanstack/react-query';

import { getShopItems } from '../shop.api';

const useFetchShopItems = () =>
  useQuery({
    queryKey: ['shop-items'],
    queryFn: getShopItems,
    keepPreviousData: true,
  });

export { useFetchShopItems };
